import { Fragment, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { LinkButton } from '../../components/BasicButton';
import { useIsMobile } from "../../misc/mobile";
import routes from "../../misc/routes";
import './AboutPage.scss';

const AboutDepartmentSelector = () => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  const getLinkButtonType = useCallback(
    (name: keyof typeof routes.about.children): 'primary' | 'secondary' => {
      return pathname === routes.about.children[ name ].path ? 'primary' : 'secondary';
    }, [ pathname ]
  );

  const departmentButtons = useMemo(() => {
    return (
      <Fragment>
        <LinkButton text="Atlétika szakosztály"
          to={ routes.about.children.atletika.path }
          type={ getLinkButtonType('atletika') } />
        <LinkButton text="Kézilabda szakosztály"
          to={ routes.about.children.kezilabda.path }
          type={ getLinkButtonType('kezilabda') } />
        <LinkButton text="Labdarúgó szakosztály"
          to={ routes.about.children.labdarugas.path }
          type={ getLinkButtonType('labdarugas') } />
        <LinkButton text="Röpladba szakosztály"
          to={ routes.about.children.roplabda.path }
          type={ getLinkButtonType('roplabda') } />
        <LinkButton text="Tollaslabda szakosztály"
          to={ routes.about.children.tollaslabda.path }
          type={ getLinkButtonType('tollaslabda') } />
        <LinkButton text="Báthory Vízi sportkör"
          to={ routes.about.children.uszas.path }
          type={ getLinkButtonType('uszas') } />
      </Fragment>
    );
  }, [ getLinkButtonType ]);

  return (
    <div className="about-department-selector">
      <LinkButton text="Bemutatkozás" to={ routes.about.path }
        type={ pathname === routes.about.path ? 'primary' : 'secondary' } />
      { isMobile ? (
        <Fragment>
          <h2>A szakosztályról</h2>
          <div><div>{ departmentButtons }</div></div>
        </Fragment>
      ) : (
        <div>
          <h2>A szakosztályról</h2>
          <div>{ departmentButtons }</div>
        </div>
      ) }
    </div>
  );
};

export default AboutDepartmentSelector;
